<template>
  <v-container
    id="features"
    tag="section"
  >
    <v-row justify="center" class="mt-6 mb-12">
      <v-col cols="12" md="9" xl="8">
        <!-- subtitle="That's where Billit comes in." -->
        <base-subheading
          class="mb-12"
          :title="`<p class='display-2 ma-0 pa-0 font-weight-bold'>
            ${
              $store.state.visitorType === 'browsing' ? 'Billing in the medical industry can be confusing for patients, providers and even billers.' : ($store.state.visitorType === 'agency' ? 'Billing for practices can be confusing for both the practice and the biller.' : 'Billing in healthcare can be confusing not just for patients, but also providers.')
            }
          </p>`"
        />
      </v-col>
    </v-row>

    <!-- <v-row align="center">
      <v-col
        cols="12"
        md="6"
      >
        <base-subheading
          :left="$vuetify.breakpoint.mdAndUp"
          subtitle="We calculate the best gas price upon order purchase. Just click Send."
          title="Premium Transactions"
        />
      </v-col>

      <v-col>
        <base-img-card :src="require('@/assets/features/2.jpg')" />
      </v-col>
    </v-row> -->

    <v-row align="center" justify="center" class="flex-row-reverse mb-12">
      <v-col cols="12" md="6" xl="5">
      <!-- :right="$vuetify.breakpoint.mdAndUp" -->
      <!-- Once you find the plan itself, there's a whole new search for how to bill that specific plan. -->
        <!-- Insurance cards are crafted in a confusing manner -->
        <base-subheading
          :left="$vuetify.breakpoint.mdAndUp"
          :subtitle="problemSubtitle"
          title="<p>The Problem</p>"
        />
      </v-col>

      <v-col cols="12" md="6" xl="5">
        <v-img eager :style="$margin('left', '-100px')" :src="require('@/assets/features/3.svg')" />
      </v-col>
    </v-row>

    <v-row align="center" justify="center" class="pt-12">
      <v-col cols="12" md="6" xl="5" :style="$margin('left', '-20px')">
        <base-subheading class="pr-1"
          :left="$vuetify.breakpoint.mdAndUp"
          :subtitle="solutionSubtitle"
          title="<p>The Solution</p>"
        />
      </v-col>

      <v-col cols="12" md="6" xl="5" class="px-0 mb-n8" :style="$margin('left', '20px')">
        <v-img eager :src="require('@/assets/features/4.svg')" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'HomeFeatures',
    computed: {
      problemSubtitle() {
        if (this.$store.state.visitorType === 'practice') {
          return `
            <span>
              <span class='font-weight-bold'>Insurance cards and their billing methods are crafted confusingly.</span> From the designs of having 2 insurance logos on the front of a card, to details such as an icon on the lower-right indicating what insurance plan the cardholder has, there’s never a guarantee that an insurance plan will be clearly indicated on a card.

              <br> <br> This can cause hesitation if you’re billing a patient with the right method, the right insurance plan, or if you’re even billing the right insurance company at all! <span class='font-weight-bold'>These issues can increase your “Days in AR”</span> (accounts receivable) average, contribute to <span class='font-weight-bold'>lost or failed collections,</span> and even bend your entire revenue flow. This can make staff training for billing a <span class='font-weight-bold'>memorization nightmare</span>.
            </span>
          `
        } else if (this.$store.state.visitorType === 'agency') {
          return `
            <span>
              Billing for different clients can be confusing & scattered. From the issues like managing what insurance plans each of your clients accept - and the confusing insurance card designs that those plans have, to the challenges like remembering each plan’s billing method for each client.

              <br> <br> This can cause hesitation if you’re billing a client’s patient with the right steps, the right insurance plan, or if you’re even billing the right insurance company at all! These issues can increase your client’s “Days in AR” (accounts receivable) average, contribute to their <span class="font-weight-bold">failed collections,</span> and even bend their entire revenue flow - all of which can damage your agency!
            </span>
          `
        } else if (this.$store.state.visitorType === 'browsing') {
          return `
            <span>
              Even in 2020, insurance billing still poses several issues for many healthcare practices and billing agencies, and even creates pressing issues for some.

              <br> <br> And it’s easy to see why, from the issues like never having the guarantee that an insurance card will clearly indicate what plan it belongs to, or not always knowing how to bill for every plan or procedure with your practice or your client’s practice - to the desires like a complete list of insurance carriers and their member plans from state-to-state, as well as a complete list of billing codes for standardized procedures. There’s many reasons why it’s hard to get a grip on the medical billing landscape.
            </span>
          `
        } else {
          return ``
        }
      },
      solutionSubtitle() {
        if (this.$store.state.visitorType === 'practice') {
          return `
            <span>
              <span class='font-weight-bold'>Insurance cards and their billing methods are crafted confusingly.</span> From the designs of having 2 insurance logos on the front of a card, to details such as an icon on the lower-right indicating what insurance plan the cardholder has, there’s never a guarantee that an insurance plan will be clearly indicated on a card.

              <br> <br> This can cause hesitation if you’re billing a patient with the right method, the right insurance plan, or if you’re even billing the right insurance company at all! <span class='font-weight-bold'>These issues can increase your “Days in AR”</span> (accounts receivable) average, contribute to <span class='font-weight-bold'>lost or failed collections,</span> and even bend your entire revenue flow. This can make staff training for billing a <span class='font-weight-bold'>memorization nightmare</span>.
            </span>
          `
        } else if (this.$store.state.visitorType === 'agency') {
          return `
            <span>
              With Billit, you can identify the plan of any insurance card that a client gives you, view a full list of insurance carriers & plans that each of your clients accept, & store custom billing instructions tailored to each of your clients billing methods for the insurance plans they accept inside of them.

              <br> <br> Billit is an easy tool to load up during a collection routine in order to view up-to-date and customized billing instructions that are tailored to your client’s billing methods for each insurance plan they accept whenever you’re billing for them - Easily and efficiently!
            </span>
          `
        } else if (this.$store.state.visitorType === 'browsing') {
          return `
            <span>
              With Billit, you can identify what plan any insurance card belongs to based on its appearance, view a full list of insurance carriers & plans that your practice or your agency’s clients accept, and you can store billing instructions inside of those listed plans that are tailored to your practice or agency’s billing methods for each insurance plan and patient procedure you accept.

              <br> <br> Billit is a tool made for healthcare practices and billing agencies to load up during a collection routine in order to view up-to-date and customized billing instructions that are tailored to their practice or their client’s billing methods for each insurance plan they accept whenever they’re billing for them - Easy, efficient, and autonomous!
            </span>
          `
        } else {
          return ``
        }
      }
    }
  }
</script>
